import { Box, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { HomeOutlined } from '@mui/icons-material';
import { Button } from '../../Button';
import type { AddressSearchListType } from './AddressSearchList';

export type AddressSearchListNoRowsType = {
  onManualSelect: AddressSearchListType['onManualSelect'];
};

export const AddressSearchListNoRows: React.VFC<AddressSearchListNoRowsType> = ({ onManualSelect }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" height="100%">
      <Box mb={2} fontSize="60px" color={grey[300]} display="flex">
        <HomeOutlined fontSize="inherit" />
      </Box>
      <Box mb={2}>
        <Typography variant="h6" color="textSecondary">
            We can&apos;t find this location
        </Typography>
      </Box>
      <Button
        type="button"
        onClick={onManualSelect}
        color="secondary"
        variant="contained"
      >Enter Address Manually</Button>
    </Box>
  );
};